// CSS Modules - component class name: MenuTeaser__

<template>
  <a :href="url" :class="$style.link">
    <span
      :class="$style.image"
      :style="`background-image: url(${image})`"
    ></span>
    <div><span v-html="title"></span></div>
  </a>
</template>

<script>
export default {
  name: "MenuTeaser",
  props: {
    title: String,
    image: String,
    url: String
  }
};
</script>

<style module lang="scss">
@import "./MenuTeaser.scss";
</style>
